import * as RentalOwnerEvents from './events-definition'
export { RentalOwnerEvents }
